export default [{"tag":"path","att":{"d":"M6 6h12v12H6V6z"}}]